import { render, staticRenderFns } from "./broadBandDetails.vue?vue&type=template&id=1f1bfcb4&scoped=true&"
import script from "./broadBandDetails.vue?vue&type=script&lang=js&"
export * from "./broadBandDetails.vue?vue&type=script&lang=js&"
import style0 from "./broadBandDetails.vue?vue&type=style&index=0&id=1f1bfcb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1bfcb4",
  null
  
)

export default component.exports